import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AdjustmentForm from "./AdjustmentComponents/AdjustmentForm";

import { useGetAdjustmentDetailQuery, useUpdateAdjustmentMutation } from "store/services/PaymentsApi/adjustmentApi";
import { useAppMeta } from "hooks";

const AdjustmentEditScreen = () => {

  const { id } = useParams();
  
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Adjustment", path: "/app/crm/adjustment/list" },
    { title: "Edit Adjustment" },
  ];

  const {
    data: adjustmentDetail,
    isLoading: loadingAdjustment,
    error,
  } = useGetAdjustmentDetailQuery(id);

  const [updateAdjustment, { isLoading: updatingAdjustment }] = useUpdateAdjustmentMutation();

  const handleUpdateAdjustment = async (data) => {
    const _payload = { ...data };

    try {
      await updateAdjustment(_payload).unwrap();
      toast.success("Adjustment successfully updated!");
      navigate(`/app/crm/adjustment/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Adjustment!"
      );
    }
  };

  useAppMeta("Edit Adjustment");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingAdjustment || updatingAdjustment}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <AdjustmentForm
          isBusy={loadingAdjustment || updatingAdjustment}
          adjustmentDetail={adjustmentDetail}
          onSubmit={handleUpdateAdjustment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AdjustmentEditScreen;
